export const CPT_RULES_VINTAGE = 'CPT 2026';
